import { Routes } from '@angular/router';
import { AuthGuard } from './services/auth-guard.service'; // Adjust path
import { HomeMainComponent } from './components/main/main.component';
import { LoginComponent } from './components/login/login.component';
import { AccountActivationComponent } from './components/login/activate.component';
import { ChangePassComponent } from './components/login/change-pass.component';
import { RegisterComponent } from './components/login/register.component';
import { ResetPassComponent } from './components/login/reset-pass.component';
import { SesaRegisterComponent } from './components/login/sesa-register.component';
import { AuthService } from './services/auth.service';
import { B2ConfigModule } from './components/b2c/B2C-config.module';
import { B2BConfigModule } from './components/b2b/B2B-config.module';
import { AccountRegisterSentComponent } from './components/login/register-sent.component';
import { CodeRequestSentComponent } from './components/login/code-request-sent.component';
import { UsersManagementComponent } from './components/admin/users-management.component';
import { AdminConfigModule } from './components/admin/admin-config.module';
import { AboutComponent } from './components/about/about.component';


export const routes: Routes = [
    { path: "", component: HomeMainComponent, data: { title: "Strona główna" } },
    { path: "logowanie", component: LoginComponent, data: { title: "Logowanie" } },
    { path: "polityka-prywatnosci", component: AboutComponent, data: { title: "About Us" } },
    { path: "glowna", redirectTo: "/", pathMatch: "full" },
    { path: "rejestracja", component: RegisterComponent, pathMatch: "full" },
    { path: "se/rejestracja", component: SesaRegisterComponent, pathMatch: "full" },
    { path: "se", component: SesaRegisterComponent, pathMatch: "full" },
    { path: "SE", component: SesaRegisterComponent, pathMatch: "full" },
    
    // Use lazy loading for the ResetPassComponent to avoid that circular dependency we fixed!
    { 
        path: "odzyskaj-konto", 
        loadComponent: () => import('./components/login/reset-pass.component').then(m => m.ResetPassComponent),
        pathMatch: "full" 
    },
    
    { path: "moje-konto", component: ChangePassComponent, pathMatch: "full" },
    { path: "haslo", component: ChangePassComponent },
    { path: "aktywuj", component: AccountActivationComponent },
    { path: "rejestracja-wyslana", component: AccountRegisterSentComponent },
    { path: "kod-aktywacyjny", component: CodeRequestSentComponent },

    // LAZY LOADING FOR SUB-MODULES (IMPORTANT)
    { 
        path: "wybierz-design", 
        loadChildren: () => import('./components/b2c/B2C-config.module').then(m => m.B2ConfigModule) 
    },
    { 
        path: "szybka-konfiguracja", 
        loadChildren: () => import('./components/b2b/B2B-config.module').then(m => m.B2BConfigModule) 
    },
    { 
        path: "admin", 
        loadChildren: () => import('./components/admin/admin-config.module').then(m => m.AdminConfigModule),
        canActivate: [AuthGuard] 
    },
    
    { path: 'uzytkownicy', data: { title: "Administracja" }, component: UsersManagementComponent, canActivate: [AuthGuard] },
    
    { path: "**", redirectTo: "/" }
];
